import { SportService } from "@prestosports/prestostats-core/Services";
import {
	GET_RULE_SET_OPTIONS_COMPLETE,
	INIT_SPORT_DATA,
	INIT_SPORT_DATA_COMPLETE
} from "./constants";

export const initSportData = async (sportId, dispatch) => {
	dispatch({
		type: INIT_SPORT_DATA
	});

	const [allowedPositions, allowedYears] = await Promise.all([
		SportService.getPlayerPositions(sportId),
		SportService.getPlayerYears()
	]);

	dispatch({
		type: INIT_SPORT_DATA_COMPLETE,
		payload: { allowedPositions, allowedYears }
	});
};

export const getRuleSetOptions = async (sportId, dispatch) => {
	const ruleSetOptions = await SportService.getRuleSetOptions(sportId);
	dispatch({ type: GET_RULE_SET_OPTIONS_COMPLETE, payload: { ruleSetOptions } });
};
